import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Button } from '@mui/material'

import ExpertiseIcon from '@/components/ui/icons/Expertise'

export function CreateExpertiseButton() {
  const location = useLocation()
  const { t } = useTranslation()

  return (
    <Button component={Link} to="/expertises/create" state={{ background: location }} variant="contained" startIcon={<ExpertiseIcon htmlColor="#FFF" />}>
      {t('page.expertises.createExpertiseButton.label')}
    </Button>
  )
}
